const _ = require('lodash'), $ = require('jquery');

module.exports = function dynamicContentHideDirective(LocalStorageService) {
    const defaultKey = 'wowHideViewedContent';

    function loadFromStorage() {
        const savedState = LocalStorageService.getItem(this._storageKey);
        if (savedState) {
            try {
                _.assign(this, _.pick(JSON.parse(savedState), 'impressions', 'isClicked'));
            } catch (e) {
                console.error('Error loading dc-hide-viewed state', e);
            }
        }
    }

    function saveToStorage() {
        localStorage.setItem(this._storageKey, JSON.stringify(_.pick(this, 'impressions', 'isClicked')));
    }

    function DynamicContentHideViewedController($scope, $element, $attrs, dynamicContentService) {
        this.$onInit = function() {
            this._storageKey = `dc_${$attrs.olyDcHideViewed || defaultKey}`;
            this._maxImpressions = parseInt($attrs.maxImpressions) || 5;
            this._dcService = dynamicContentService;
            this.impressions = 0;
            this.isClicked = false;

            loadFromStorage.call(this);

            // Whenever we instantiate the directive, that counts as an impression.
            this.impressions += 1;

            $element.on('click.dcHideViewed', this.clicked.bind(this, true));
            $(window).on('unload.dcHideViewed', saveToStorage.bind(this));

            $scope.$on('$destroy', function () {
                saveToStorage.call(this);
                $element.off('click.dcHideViewed');
                $(window).off('unload.dcHideViewed');
            }.bind(this));

            if (!this.shouldShow()) {
                $element.detach();
            }
        };
    }

    DynamicContentHideViewedController.prototype.shouldShow = function () {
        return this._dcService.isManagementEnabled() || (this.impressions <= this._maxImpressions) && !this.isClicked;
    };

    DynamicContentHideViewedController.prototype.clicked = function (isClicked) {
        if (isClicked !== undefined) {
            this.isClicked = isClicked;
        }

        return isClicked;
    };

    return {
        restrict: 'A',
        controller: ['$scope', '$element', '$attrs', 'DynamicContentService', DynamicContentHideViewedController]
    };
};


/** WEBPACK FOOTER **
 ** ./wowapp/src/shop/components/dynamiccontent/dynamic-content-hide-viewed-directive.js
 **/